import React, { useState } from "react";

import Presentation from "./presentation";

const component = props => {

	const [ anchorEl, setAnchorEl ] = useState ( null );

	const handleClick = event => {
		setAnchorEl ( event.currentTarget );
	};

	const handleClose = () => {

		setAnchorEl ( null );
	};

	return (
		<Presentation
			{ ...props }
			anchorEl    = { anchorEl }
			handleClick = { handleClick }
			handleClose = { handleClose }
		/>
	);
};

export default component;
